import { put, call, takeLatest } from 'redux-saga/effects';
import * as api from './Api';
import { push } from 'react-router-redux';
import { actions } from './Reducer';
import {
  setSupplierPrivateInquiryIsLoading,
  getSupplierPrivateInquirySuccessAction,
  getSupplierPrivateInquiriesSuccessAction,
  deleteSupplierPrivateInquirySuccessAction,
  editSupplierPrivateInquirySuccessAction,
  addSupplierPrivateInquirySuccessAction,
  setPrivateSupplierInquiryAction,
  getSupplierPrivateStagingInquiriesAction
} from './Actions';

import {
  errorNotificationFromError,
  newSuccessNotificationAction
} from '../../../notifications/Actions';

function* getSupplierPrivateInquiry({ payload }) {
  const inquireyId = payload;
  const body = {
    inquiryID: inquireyId
  };

  try {
    yield put(setSupplierPrivateInquiryIsLoading(true));
    const response = yield call(api.getSupplierPrivateInquiry, body);
    const { data } = response;
    const { content, count } = data;
    console.log(data);
    yield put(getSupplierPrivateInquirySuccessAction(data));
    yield put(newSuccessNotificationAction('Get Private Inquiry'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierPrivateInquiryIsLoading(false));
  }
}

const searchData = {
  offset: 0,
  size: 10,
  searchTerm: '',
  filterBy: [],
  // filterCustomerID: customerId,
  filterSupplierID: '',
  sort: 'createdAt',
  dir: 'asc'
};

function* getSupplierPrivateInquiries({ payload }) {
  const body = { ...payload, ...searchData };
  try {
    yield put(setSupplierPrivateInquiryIsLoading(true));
    const response = yield call(api.getSupplierPrivateInquiries, body);
    const { data } = response;
    const { count, content } = data;
    yield put(getSupplierPrivateInquiriesSuccessAction(content));
    // yield put(getSupplierPrivateStagingInquiriesAction(staging))
    yield put(setPrivateSupplierInquiryAction(count));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierPrivateInquiryIsLoading(false));
  }
}

function* deleteSupplierPrivateInquiry({ payload }) {
  const {_id} = payload;
  console.log(payload, 'payload');
  try {
    yield put(setSupplierPrivateInquiryIsLoading(true));
    yield call(
      api.deleteArtisanPrivateInquiry,
      payload
    );
    yield put(deleteSupplierPrivateInquirySuccessAction(_id));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierPrivateInquiryIsLoading(false));
  }
}

function* editSupplierPrivateInquiry({ payload: { id, body } }) {
  try {
    yield put(setSupplierPrivateInquiryIsLoading(true));
    const response = yield call(api.editSupplierPrivateInquiry, id, body);
    const { data } = response;
    // yield put(editSupplierPrivateInquirySuccessAction(data));
    yield put(newSuccessNotificationAction('Inquiry Edited'));
    yield put(push('/customer-private-inquiry-supplier/'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierPrivateInquiryIsLoading(false));
  }
}

function* addSupplierPrivateInquiry({ payload }) {
  try {
    yield put(setSupplierPrivateInquiryIsLoading(true));
    const response = yield call(api.addSupplierPrivateinquiry, payload);
    const { data } = response;
    // yield put(addSupplierPrivateInquirySuccessAction(data));
    yield put(newSuccessNotificationAction('Inquiry Added'));
    yield put(push('/customer-private-inquiry-supplier/'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierPrivateInquiryIsLoading(false));
  }
}

export default function*() {
  yield takeLatest(
    actions.GET_SUPPLIER_PRIVATE_INQUIREY,
    getSupplierPrivateInquiry
  );
  yield takeLatest(
    actions.GET_SUPPLIER_PRIVATE_INQUIRIES,
    getSupplierPrivateInquiries
  );
  yield takeLatest(
    actions.DELETE_PRIVATE_SUPPLIER_INQUIRY,
    deleteSupplierPrivateInquiry
  );
  yield takeLatest(
    actions.EDIT_PRIVATE_SUPPLIER_INQUIRY,
    editSupplierPrivateInquiry
  );
  yield takeLatest(
    actions.ADD_PRIVATE_SUPPLIER_INQUIRY,
    addSupplierPrivateInquiry
  );
}
